import WorkflowPublish from '@apps/truevail/admin/components/workflow_publish'
import LibraryAdd from '@apps/truevail/admin/components/library_add'
import TagsToken from '@apps/crm/admin/tokens/tags'
import Details from '@admin/components/details'
import Button from '@admin/components/button'
import Panel from '@admin/components/panel'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import Clone from '../clone'
import Edit from '../edit'
import React from 'react'

const enrollment = {
  false: 't(Contacts can be enrolled in this workflow multiple times)',
  true: 't(Contacts can only be enrolled in this workflow once)'
}

const Overview = ({ workflow }) => {

  const form = workflow.form ? {
    label: workflow.form.title,
    className: 'link',
    route: `/truevail/admin/forms/${workflow.form.id}`
  } : null

  const details = {
    audits: `truevail_workflows/${workflow.id}`,
    comments: `truevail_workflows/${workflow.id}`,
    sections: [
      {
        title: 't(Workflow Details)',
        items: [
          { label: 't(Title)', content: workflow.title },
          { label: 't(Trigger)', content: <T text={ workflow.trigger.text } /> },
          ...workflow.tag ? [
            { label: 't(Tag)', content: workflow.tag }
          ] : [],
          { label: 't(Enrollment)', content: <T text={ enrollment[workflow.is_unique] } /> },
          ...form ? [
            { label: 't(Form)', content: <Button { ...form } /> }
          ]: []
        ]
      },
      ...!form ? [
        {
          title: 't(Library Details)',
          items: [
            { label: 't(Folders)', content: workflow.folders.length > 0 ? workflow.folders.map(folder => folder.title).join(', ') : null },
            { label: 't(Tags)', content: workflow.tags.length > 0 ? <TagsToken tags={ workflow.tags } /> : null }  
          ]
        }  
      ] : []
    ]
  }

  if(workflow.deleted_at !== null) {
    details.alert = { color: 'red', message: 't(This workflow was deleted)' }
  } else if(!workflow.form && workflow.status === 'draft') {
    details.alert = { color: 'grey', message: 't(This workflow is not published to the library)' }
  } else if(!workflow.form && workflow.status === 'published') {
    details.alert = { color: 'green', message: 't(This workflow is published to the library)' }
  }

  return <Details { ...details } />

}

Overview.propTypes = {
  workflow: PropTypes.object
}

const mapPropsToPanel = (props, context) => ({
  title: 't(Overview)',
  panel: <Overview workflow={ props.workflow } />,
  tasks: {
    items: [
      {
        label: 't(Edit Workflow)',
        svg: 'square_pen',
        modal: <Edit workflow={ props.workflow } />
      },
      {
        label: 't(Duplicate Workflow)',
        svg: 'copy',
        modal: <Clone workflow={ props.workflow } />
      },
      {
        label: 't(Add to Library)',
        svg: 'book_plus',
        show: !props.workflow.form && props.workflow.status === 'draft',
        modal: <LibraryAdd scope="admin" entity="workflows" record={ props.workflow } />
      },
      {
        label: 't(Remove from Library)',
        svg: 'book_minus',
        show: !props.workflow.form && props.workflow.status === 'published',
        request: {
          endpoint: `/api/admin/truevail/admin/workflows/${props.workflow.id}/unpublish`,
          method: 'PATCH',
          onSuccess: () => context.flash.set('success', 't(Successfully unpublished this workflow)'),
          onFailure: () => context.flash.set('error', 't(Unable to unpublish this workflow)')
        }
      },
      {
        label: 't(Publish Advisor Workflow)',
        svg: 'user_round',
        modal: <WorkflowPublish workflow_id={ props.workflow.id } entity="admin" />
      },
      {
        label: 't(Delete Workflow)',
        svg: 'trash',
        confirm: 't(Are you sure you want to delete this workflow?)',
        deletable: true,
        request: {
          endpoint: `/api/admin/truevail/admin/workflows/${props.workflow.id}`,
          method: 'DELETE',
          onSuccess: () => {
            context.flash.set('success', 't(Successfully deleted workflow)')
            context.router.goBack()
          },
          onFailure: () => context.flash.set('error', 't(Unable to delete workflow)')
        }
      }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
